import { SerializedError } from "@reduxjs/toolkit";

export const asyncInittalState = {
    loading: false,
    error: null as string | null,
};

export type AsyncState = {
    loading: boolean;
    error: string | null;
}

export const handleAsync = {
    pending: (state: AsyncState) => {
        state.loading = true;
        state.error = null;
    },
    fulFilled: (state: AsyncState) => {
        state.loading = false;
    },
    rejected: (state: AsyncState, action: { error: SerializedError }) => {
        state.loading = false;
        console.log(action.error.message);
    }
}